import moment from 'moment';
import WP from 'WP';

import { capitalize } from 'helpers';


export const getDate = date => {
    return capitalize(moment(new Date(date).toUTCString()).format('MMM'));
}
 
export const getSeason = season => {
    let fromDate, toDate;
    let fromString = WP.options[`${season}_from_date`];
    let toString = WP.options[`${season}_to_date`];
    
    let from = fromString.split('');
    from.splice(2, 0, '-');
    let fromStr = from.join('');

    let to = toString.split('');
    to.splice(2, 0, '-');
    let toStr = to.join('');

    fromDate = new Date().getFullYear() + '-' + fromStr;
    toDate = new Date().getFullYear() + '-' + toStr;

    let fromUTC = new Date(fromDate).toUTCString();
    let toUTC = new Date(toDate).toUTCString()

    let fromRes = capitalize(moment(new Date(fromUTC)).format('Do MMM'));
    let toRes = capitalize(moment(new Date(toUTC)).format('Do MMM'));

    return fromRes + ' – ' + toRes
}